<script lang="ts">
  import type { SyncStatus } from '../sync/sync';

  let { status }: { status: SyncStatus | 'disabled' } = $props();
</script>

<!-- Sync indicator (design doc §9.6): a small sage dot that breathes while
     syncing — no spinners. Chrome-only animation; never in the ink path. -->
<span
  class="dot"
  class:syncing={status === 'syncing'}
  class:hollow={status === 'disabled' || status === 'offline'}
  class:error={status === 'error'}
  title="Sync: {status}"
  role="status"
  aria-label="Sync: {status}"
></span>

<style>
  .dot {
    width: 10px;
    height: 10px;
    flex: none;
    border-radius: 50%;
    background: var(--accent-2);
    display: inline-block;
  }
  .dot.hollow {
    background: transparent;
    border: 1.5px solid color-mix(in srgb, var(--ink-primary) 35%, transparent);
  }
  .dot.error {
    background: color-mix(in srgb, #c0564a 70%, var(--surface));
  }
  .dot.syncing {
    animation: breathe 1.6s ease-in-out infinite;
  }
  @keyframes breathe {
    0%, 100% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.35); opacity: 0.55; }
  }
  @media (prefers-reduced-motion: reduce) {
    .dot.syncing { animation: none; }
  }
</style>
